import React from 'react';
import WelcomeSection from './components/WelcomeSection';
import ActionCards from './components/ActionCards';
// import QuickStats from './components/QuickStats';
import Layout from '@/common/Layout';
import FloatingActionButton from '../FloatingActionButton';
import { getLoggedInUser } from 'utilities/helpers';
const Dashboard = () => {
  const user = getLoggedInUser();
  return (
    <Layout sider={false}>
      <WelcomeSection />
      <ActionCards />
      {[1, 3].includes(user?.user_details?.role_id) ? (
        <FloatingActionButton />
      ) : (
        ''
      )}
    </Layout>
  );
};

export default Dashboard;
